// @flow

import React from 'react';
import { withRouter, Link } from 'react-router-dom';
import { css } from 'react-emotion';

import WhiteSpaceSvgWrapper from '../../../components/WhiteSpaceSvgWrapper';
import Email from '../../../components/Email.svg';
import TempRightActionHelper from '../components/TempRightActionHelper';
import { elements, components, fonts, copy } from '@peachjar/components';
import config from '../../../../config'

const { ProximaNova } = fonts;
const { FullSpread, ContentColumn, WhitespaceColumn, Buttons } = components;
const { Quote } = elements;

const { quotes } = copy;
const { ButtonPrimaryLarge } = Buttons;
const { REACT_APP_PEACHJAR_HOME_PAGE } = config;

const styles = {
  header: css({
    fontSize: '34px',
    fontWeight: '600',
    marginBottom: '1rem',
    fontFamily: ProximaNova,
  }),
  paragraph: css({
    marginBottom: '1rem',
    maxWidth: '512px',
    fontFamily: ProximaNova,
  }),
};

const quote = {
  content:
    'Tell me and I forget, teach me and I may remember, involve me and I learn.',
  author: 'Benjamin Franklin',
};

export const RFPThankYou = () => (
  <FullSpread>
    <ContentColumn leftAction={<div />} rightAction={<TempRightActionHelper />}>
      <div className="layout-column layout-align-start-start">
        <h1 className={styles.header}>Thank you!</h1>
        <p className={styles.paragraph}>
          {`We'll reach out to you in 1-2 business days with a proposal. If you
          haven't heard from us within that time please contact us.`}
        </p>

        <ButtonPrimaryLarge
          data-testid="click-backToHomeButton"
          onClick={() => {
            window.location.href = REACT_APP_PEACHJAR_HOME_PAGE
          }}
        >
          Back to Home
        </ButtonPrimaryLarge>
      </div>
    </ContentColumn>
    <WhitespaceColumn>
      <WhiteSpaceSvgWrapper
        svg={<Email />}
        quote={quotes.grayson_modernizing}
      />
    </WhitespaceColumn>
  </FullSpread>
);

export default RFPThankYou;



// WEBPACK FOOTER //
// ./src/Onboarding/Registration/onboarding/containers/RFPThankYou.jsx